import React from 'react'
import get from 'lodash/get'
import { identify } from '../globals/tracking/tracking-execution'
import { generateSessionId } from '../helper/session-id'
import { getGlobals, setGlobals } from '../globals/globals'
import SEO from './seo'
import ProgressBar from './progress-bar'
import getQueryParameter from '../helper/get-query-parameter'
import { CalendlyScriptProvider } from 'lemon-campaign-ui/lib/hoc/calendlyScript'
import { getUserId, handleAnonId } from '../globals/storage'

function getCurrentProgress(props, progressTotal) {
  const { pageContext } = props

  const pos = pageContext.sortedPages.indexOf(pageContext.pageId)
  if (pos === -1) {
    return progressTotal
  }

  return pos + 1
}

export default class PageWrapper extends React.Component {
  constructor(props) {
    super(props)

    if (typeof window !== `undefined`) {
      window.Rollbar.configure({ hostWhiteList: [props.pageContext.url] })
    }

    handleAnonId()
    const sessionId = generateSessionId()
    setGlobals({
      perspectiveSessionId: sessionId,
      anonymousId: getUserId(),
    })
  }

  componentDidMount() {
    const initialTraits = this.getInitialTraits()
    identify(initialTraits)
    const { perspectiveSessionId } = getGlobals()
    window.Rollbar.configure({ payload: { sessionId: perspectiveSessionId } })
  }

  // Global Error Catcher
  componentDidCatch(error, errorInfo) {
    window.Rollbar.error(error) // eslint-disable-line no-undef
  }

  getInitialTraits() {
    const queryParams = getQueryParameter()
    const traits = queryParams.custom

    return traits
  }

  render() {
    const { element, pageContext, data } = this.props
    let progressTotal = get(pageContext, 'sortedPages.length')

    const hasResultPages = get(data, 'campaignData.pages', []).filter(({ isResult }) => !!isResult).length

    if (!!hasResultPages) {
      progressTotal += 1
    }

    let progressBar = null

    if (!pageContext.cookiePolicyPage) {
      progressBar = (
        <ProgressBar key="progress-bar" total={progressTotal} current={getCurrentProgress(this.props, progressTotal)} />
      )
    }

    return (
      <React.Fragment>
        <SEO url={pageContext.url} />

        <CalendlyScriptProvider>{element}</CalendlyScriptProvider>

        {progressBar}
      </React.Fragment>
    )
  }
}
